{
  "#MDC_STOCK_POSTING": {
    "TITLE": "Lagerbuchung",
    "MODULE_TITLE": "Lagerbuchung"
  }
}
